import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ScrollToTop from "./components/layout/ScrollToTop";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import HomePage from "./pages/HomePage/HomePage";
import ArticlesPage from "./pages/ArticlesPage/ArticlesPage";
import ArticleDetailPage from "./pages/ArticleDetailPage/ArticleDetailPage";
import SubmitArticlePage from "./pages/SubmitArticlePage/SubmitArticlePage";
import LoginPage from "./pages/LoginPage/LoginPage";
import SignUpPage from "./pages/SignUpPage/SignUpPage";
import ProfilePage from "./pages/ProfilePage/ProfilePage";
import WriterProfilePage from "./pages/WriterProfilePage/WriterProfilePage";
import DashboardPage from "./pages/DashboardPage/DashboardPage";
import PrivateRoute from "./components/auth/PrivateRoute";
import AuthorsPage from "./pages/AuthorsPage/AuthorsPage";
import AdminFeaturedArticlePage from "./pages/AdminFeaturedArticlePage/AdminFeaturedArticlePage";
import "./App.css";
import "./editorial.css";

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div id="top" className="App min-h-screen bg-white">
          <Navbar />
          <main className="pt-16">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/articles" element={<ArticlesPage />} />
              <Route path="/articles/:category" element={<ArticlesPage />} />
              <Route path="/article/:slug" element={<ArticleDetailPage />} />
              <Route path="/writer/:id" element={<WriterProfilePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignUpPage />} />
              
              {/* Protected Routes */}
              <Route path="/submit" element={
                <PrivateRoute>
                  <SubmitArticlePage />
                </PrivateRoute>
              } />
              <Route path="/profile" element={
                <PrivateRoute>
                  <ProfilePage />
                </PrivateRoute>
              } />
              <Route path="/dashboard" element={
                <PrivateRoute>
                  <DashboardPage />
                </PrivateRoute>
              } />
              <Route path="/authors" element={<AuthorsPage />} />
              <Route path="/admin/featured-article" element={
                <PrivateRoute requireAdmin>
                  <AdminFeaturedArticlePage />
                </PrivateRoute>
              } />
              <Route path="/new-article" element={
                <PrivateRoute>
                  <SubmitArticlePage />
                </PrivateRoute>
              } />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
